import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import { CommonHeader, EmptyListPage, ErrorSuccessModal } from "../../../components/commons";
import CostOfGoodsHeader from "../../../components/Reports/CostOfGoods/CostOfGoodsHeader";
import { formatDate } from "../../../utils/commonFunctions";
import { GetCostOfGoodsPayloadType } from "../../../commonTypes/reportsTypes";
import {
  getCostOfGoodsAction,
  resetCostOfGoodsData,
  resetReportsError,
  resetReportsFetching,
  resetReportsSuccess,
} from "../../../redux/reports";
import { resetSession } from "../../../redux/auth";
import { CostOfGoodsType, ListCostOfGoods } from "../../../redux/reports/reportsType";
import CostOfGoodsTable from "../../../components/Reports/CostOfGoods/CostOfGoodsTable";
import { BalanceSheetImage } from "../../../assets/images";
import SkeltonElement from "../../../components/commons/SkeltonLoader/SkeltonElement";
import CostOfGoodsFooter from "../../../components/Reports/CostOfGoods/CostOfGoodsFooter";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import { downloadCostOfGoodsReportsApi } from "../../../apis/reportsApis";
import FileSaver from "file-saver";
import { Excel } from "../../../components/Icon";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";

type AppProps = {
  history?: any;
  token: string | null;
  dispatchResetSession: () => void;
  dispatchResetReportsErrorAction: () => void;
  dispatchResetReportsSuccessAction: () => void;
  dispatchResetReportsFetchingAction: () => void;
  fetching: boolean;
  companyName:string;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  costOfGoods: CostOfGoodsType;
  dispatchGetCostOfGoodsAction: (data: GetCostOfGoodsPayloadType) => void;
  currencySign: string | undefined;
  dispatchResetCostOfGoodsData: () => void;
};

const CostOfGoods = ({
  history,
  token,
  fetching,
  error,
  success,
  statusCode,
  dispatchResetReportsErrorAction,
  dispatchResetReportsSuccessAction,
  dispatchResetSession,
  dispatchResetReportsFetchingAction,
  costOfGoods,
  dispatchGetCostOfGoodsAction,
  currencySign,
  companyName,
  dispatchResetCostOfGoodsData,
}: AppProps) => {
  const client_code = history?.location?.state?.client_code;
  const company_name = history?.location?.state?.company_name ? history?.location?.state?.company_name  :  companyName;

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [toggle, setToggle] = useState<boolean>(false);
  const [displayStartDate, setDisplayStartDate] = useState("")
  const [displayEndDate, setDisplayEndDate] = useState("")
  const [data, setData] = useState<CostOfGoodsType>({
    opening_stock: 0, //opening stock
    closing_stock: 0, // closing stock
    gross_profit: 0, //gross total
    total_cogs: 0, // total cost of gooods
    total_income: 0, /// total income
    total_direct_income: 0, ///direct ledger  income
    total_indirect_income: 0, /// indirect ledger income
    total_expense: 0, // total expense
    total_direct_expense: 0, // total cost of all direct expense ledger
    total_indirect_expense: 0, /// all indirect expense ledger
    net_profit: 0, // total net profit
    direct_expenses: [], //all direct expense ledger
    indirect_expenses: [], // all indirect expense ledger
    indirect_income: [], // indirect ledger list
    direct_income: [], // direct ledger list
  });
  const [isDownloadCostOfGoodPresent, setIsDownloadCostOfGoodPresent] =
    useMenuCheck();
  const [isLedgerStatementPresent, setIsLedgerStatementPresent] =
    useMenuCheck();
  const finalRedirectLink = {
    pathname: `/reports/${client_code}/ledger-statement?client_code=${client_code}&company_name=${company_name}`,
  };
  useEffect(() => {
    setIsDownloadCostOfGoodPresent("Download Trading, Profit & Loss Report", "menu")
    setIsLedgerStatementPresent("Ledger Statement", "menu");
    localStorage.removeItem('start_date');
    localStorage.removeItem('end_date');
    dispatchResetReportsErrorAction();
    dispatchResetReportsSuccessAction();
    dispatchResetReportsFetchingAction();
    dispatchResetCostOfGoodsData();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setData({
      ...costOfGoods,
    });
  }, [costOfGoods]);

  const handleStartDateChange = (date: string) => {
    const value = formatDate(date);
    setStartDate(value);
  };

  const handleEndDateChange = (date: string) => {
    const value = formatDate(date);
    setEndDate(value);
  };
  const handleSubmitData = () => {

    if (endDate && startDate && token) {
      setDisplayStartDate(startDate)
      setDisplayEndDate(endDate)
      let finalData: GetCostOfGoodsPayloadType = {
        token,
        start_date: startDate,
        end_date: endDate,
        client_code,
      };
      dispatchGetCostOfGoodsAction(finalData);
    }
  };


  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetReportsErrorAction();
            }}
          />
        );
      }
    }

    return false;
  };

  ///collapse and expend function 
  function mapIt(data: ListCostOfGoods[], action: boolean) {
    return data.map((e: ListCostOfGoods) => {
      if (e?.data) {
        e = { ...e, isOpens: action };
        if (e.data) {
          e.data = mapIt(e.data, action);
        }
      }
      return e;
    });
  }


  const hanldeOpenAll: any = (dataArray: any, type: string) => {


    if (type === "Income") {
      dataArray.shift();
      let openArray = mapIt(dataArray, true);

      setData((prv: CostOfGoodsType) => {
        return {
          ...prv,
          direct_income: openArray
        }
      })
    };

    if (type === "Incomes") {
      dataArray.shift();
      let openArray = mapIt(dataArray, true);

      setData((prv: CostOfGoodsType) => {
        return {
          ...prv,
          indirect_income: openArray
        }
      })
    };

    if (type === "Expense") {

      let openArray = mapIt(dataArray, true);

      setData((prv: CostOfGoodsType) => {
        return {
          ...prv,
          indirect_expenses: [...openArray]
        }
      })
    };

    if (type === "cost_of_goods_sold") {

      let openArray = mapIt(dataArray, true);

      setData((prv: CostOfGoodsType) => {
        return {
          ...prv,
          direct_expenses: [...openArray]
        }
      })
    }


  }

  const hanldeCloseAll = (dataArray: any, type: string) => {
    if (type === "Income") {
      dataArray.shift();
      let openArray = mapIt(dataArray, false)

      setData((prv: CostOfGoodsType) => {
        return {
          ...prv,
          direct_income: openArray
        }
      })
    }
    if (type === "Incomes") {
      dataArray.shift();
      let openArray = mapIt(dataArray, false)

      setData((prv: CostOfGoodsType) => {
        return {
          ...prv,
          indirect_income: openArray
        }
      })
    }
    if (type === "Expense") {

      let openArray = mapIt(dataArray, false);

      setData((prv: CostOfGoodsType) => {
        return {
          ...prv,
          indirect_expenses: [...openArray]
        }
      })
    }
  }

  const renderDownloadCostOfGoodsToolTip = (props: any) => {
    return (
      <Tooltip id="button-view-open-item" {...props}>
        Download Excel
      </Tooltip>
    );
  };

  const handlePrepareDownload = () => {
    let params: GetCostOfGoodsPayloadType = {
      start_date: displayStartDate,
      end_date: displayEndDate,
      client_code,
      token,
    };

    if (params && token) {
      handleDownload(params);
    }
  };
  const handleDownload = (params: GetCostOfGoodsPayloadType) => {
    let reportName = company_name
      ? company_name +
      "-" +
      displayStartDate +
      " to " +
      displayEndDate +
      ".xlsx"
      : "report";
    downloadCostOfGoodsReportsApi(params).then((response: any) => {

      let blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8" });
      FileSaver.saveAs(blob, reportName);
      toast.success("Report Downloaded Successfully!", {
        duration: 3000,
      });
    });
  };
  return (
    <>
      <div className="col-md-6">
        <CommonHeader
          title="Trading, Profit & Loss"
          company_name={company_name}
          client_code={client_code}
        />
      </div>
      <div className="report-card mt-4">
        <div className="inside-report-card">
          <CostOfGoodsHeader
            setToggle={setToggle}
            toggle={toggle}
            startDate={startDate}
            endDate={endDate}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
            handleSubmitData={handleSubmitData}
          />
          <hr className="mt-4 mb-4" style={{ width: "97%" }} />




          {(costOfGoods?.direct_expenses?.length == 0 &&
            costOfGoods?.indirect_expenses?.length == 0 &&
            costOfGoods?.indirect_income?.length == 0 &&
            costOfGoods?.indirect_income?.length == 0 &&

            !fetching) ? (
            <div className="mt-5 mb-5">
              <EmptyListPage
                title={`No Data Found!`}
                text={`Choose a date to get Trading, Profit & Loss.`}
                image={BalanceSheetImage}
                imageWidth="30%"
              />
            </div>
          ) : <>


            <div className="d-flex">
              <div className='d-flex flex-column ' style={{ flex: "22" }}>


                <div className="d-flex justify-content-center " style={{ flexDirection: "column" }}>
                  {displayStartDate && displayEndDate && (
                    <>
                      <h4 className={"text-center"} style={{
                        fontSize: "22px",
                        fontWeight: 600
                      }}>Trading, Profit & Loss</h4>
                      <span className="font-weight-bolder text-center text-lighter" style={{ color: "#7c8db0" }}>
                        {fetching ? (
                          <div style={{ margin: "auto" }}>
                            <SkeltonElement type="title" />
                          </div>
                        ) : (
                          <div style={{ display: "flex", gap: "20px", justifyContent: "center" }}>
                            <h6>
                              Start Date {displayStartDate}
                            </h6>
                            <h6>
                              End Date {displayEndDate}
                            </h6>
                          </div>
                        )}
                      </span>
                    </>
                  )}
                </div>
              </div>


              {fetching ? <></> : <div className='d-flex align-items-center mr-2' style={{ flex: "1" }}>
                {isDownloadCostOfGoodPresent && <span style={{ marginTop: "-15px" }}>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 250 }}
                    overlay={renderDownloadCostOfGoodsToolTip}
                  >
                    <button
                      style={{ border: "none" }}
                      onClick={handlePrepareDownload}
                    >
                      <Excel />
                    </button>
                  </OverlayTrigger>
                </span>}
              </div>}
            </div>
            {/* income direct  */}

            <CostOfGoodsTable
              data={[
                {
                  ledger_id: "Direct Ledgers",
                  ledger_type_id: "Direct Ledgers",
                  parent_id: 0,
                  ledger_name: "Direct Ledgers",
                  total_amount: data?.total_direct_income,
                  cog_type: 0,
                },
                ...data?.direct_income,
              ]}
              subHeader={"Income"}
              total={data?.total_direct_income}
              fetching={fetching}
              currencySign={currencySign}
              hanldeOpenAll={hanldeOpenAll}
              hanldeCloseAll={hanldeCloseAll}
              startDate={displayStartDate}
              endDate={displayEndDate}
              finalRedirectLink={finalRedirectLink}
              isLedgerStatementPresent={isLedgerStatementPresent}
            />


            {/* cost of goods sold */}

            <CostOfGoodsTable
              data={[
                {
                  ledger_id: "Opening Stock",
                  ledger_type_id: "Opening Stock",
                  parent_id: 0,
                  ledger_name: "Opening Stock",
                  total_amount: data?.opening_stock,
                  cog_type: 0,
                },
                {
                  ledger_id: "All Direct Expense Ledger",
                  ledger_type_id: "All Direct Expense Ledger",
                  parent_id: 1,
                  ledger_name: "All Direct Expense Ledger",
                  total_amount: data?.total_direct_expense,
                  cog_type: 0,
                  data: [...data?.direct_expenses]
                },
                {
                  ledger_id: "TOTAL COST OF ALL DIRECT EXPENSE LEDGER",
                  ledger_type_id: "TOTAL COST OF ALL DIRECT EXPENSE LEDGER",
                  parent_id: 0,
                  ledger_name: "TOTAL COST OF ALL DIRECT EXPENSE LEDGER",
                  total_amount: data?.total_direct_expense,
                  cog_type: 0,
                },
                {
                  ledger_id: "Closing Stock",
                  ledger_type_id: "Closing Stock",
                  parent_id: 0,
                  ledger_name: "Closing Stock",
                  total_amount: data?.closing_stock,
                  cog_type: 0,
                },


              ]}
              subHeader={"cost_of_goods_sold"}
              total={data?.gross_profit}
              // endDate={date}
              fetching={fetching}
              currencySign={currencySign}
              totalDirectExpense={data?.total_cogs} //total_cogs
              closeingStock={data?.closing_stock}
              startDate={displayStartDate}
              endDate={displayEndDate}
              hanldeOpenAll={hanldeOpenAll}
              hanldeCloseAll={hanldeCloseAll}
              finalRedirectLink={finalRedirectLink}
              isLedgerStatementPresent={isLedgerStatementPresent}

            />

            {/* income indirect ladgers */}

            <CostOfGoodsTable
              data={[
                {
                  ledger_id: "Indirect Ledgers",
                  ledger_type_id: "Indirect Ledgers",
                  parent_id: 0,
                  ledger_name: "Indirect Ledgers",
                  total_amount: data?.total_indirect_income,
                  cog_type: 0,
                },
                ...data?.indirect_income,
              ]}
              subHeader={"Incomes"}
              total={data?.total_indirect_income}
              fetching={fetching}
              currencySign={currencySign}
              startDate={displayStartDate}
              endDate={displayEndDate}
              hanldeOpenAll={hanldeOpenAll}
              hanldeCloseAll={hanldeCloseAll}
              finalRedirectLink={finalRedirectLink}
              isLedgerStatementPresent={isLedgerStatementPresent}

            />


            {/* Expense */}

            <CostOfGoodsTable
              data={data?.indirect_expenses[0] && data?.indirect_expenses[0]?.data && data?.indirect_expenses[0]?.ledger_type_id === "All Indirect Expense Ledger" ? [{
                ledger_id: "All Indirect Expense Ledger",
                ledger_type_id: "All Indirect Expense Ledger",
                parent_id: 1,
                ledger_name: "All Indirect Expense Ledger",
                total_amount: data?.total_indirect_expense,
                cog_type: 0,
                isOpens: data?.indirect_expenses[0]?.isOpens,
                data: data?.indirect_expenses[0]?.data
              }] : [
                {
                  ledger_id: "Indirect Ledgers",
                  ledger_type_id: "Indirect Ledgers",
                  parent_id: 0,
                  ledger_name: "Indirect Ledgers",
                  total_amount: data?.total_indirect_income,
                  cog_type: 0
                },
              
                ...data?.indirect_expenses,
              ]}
              subHeader={"Expense"}
              total={data?.total_indirect_expense}
              fetching={fetching}
              currencySign={currencySign}
              startDate={displayStartDate}
              endDate={displayEndDate}
              hanldeOpenAll={hanldeOpenAll}
              hanldeCloseAll={hanldeCloseAll}
              finalRedirectLink={finalRedirectLink}
              isLedgerStatementPresent={isLedgerStatementPresent}

            />
            <CostOfGoodsFooter
              sideHeading={"TOTAL NET PROFIT"}
              currencySign={currencySign}
              data={data?.net_profit}
            />
          </>


          }
        </div>
      </div>
      {handleErrorModal()}
      <Toaster />
    </>
  );
};
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.reports.success,
  fetching: state.reports.fetching,
  error: state.reports.error,
  statusCode: state.reports.statusCode,
  costOfGoods: state.reports.costOfGoods,
  currencySign: state.auth.currencySign,
  companyName: state.auth.companyName
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetReportsErrorAction: () => dispatch(resetReportsError()),
  dispatchResetReportsSuccessAction: () => dispatch(resetReportsSuccess()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetReportsFetchingAction: () => dispatch(resetReportsFetching()),
  dispatchGetCostOfGoodsAction: (data: GetCostOfGoodsPayloadType) =>
    dispatch(getCostOfGoodsAction(data)),
  dispatchResetCostOfGoodsData: () => dispatch(resetCostOfGoodsData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CostOfGoods);
